import React, { Component } from "react";
import logo2 from "../assets/logo2.png";

class SeminarDindang2 extends Component {
  state = {
    registered: {},
  };

  seminar = "dindang"; // ✅ unique name for this seminar

  componentDidMount() {
    this.fetchRegistered();
    // Optional auto-refresh every 10 seconds
    this.interval = setInterval(this.fetchRegistered, 10000);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  // ✅ Universal fetch method
  fetchRegistered = async () => {
    try {
      const res = await fetch(`/api/registered?seminar=${this.seminar}`);
      const data = await res.json();
      this.setState({ registered: data });
    } catch (err) {
      console.error(`Error fetching ${this.seminar} data:`, err);
    }
  };

  // ✅ Shared register/unregister logic
  handleRegister = async (id) => {
    const isRegistered = this.state.registered[id];

    if (isRegistered) {
      const pin = window.prompt("Enter PIN to unregister:");
      const res = await fetch("/api/unregister", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ seminar: this.seminar, id, pin }),
      });
      if (res.ok) {
        const data = await res.json();
        this.setState({ registered: data });
        alert("Unregistered successfully.");
      } else {
        alert("Incorrect PIN. Unregister cancelled.");
      }
    } else {
      const confirmRegister = window.confirm("Do you want to register?");
      if (confirmRegister) {
        const res = await fetch("/api/register", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ seminar: this.seminar, id }),
        });
        const data = await res.json();
        this.setState({ registered: data });
      }
    }
  };

  // ✅ Render participant dynamically
  renderParticipant = (id, name) => {
    const isRegistered = this.state.registered[id];
    return (
      <div key={id}>
        <span
          onClick={() => this.handleRegister(id)}
          style={{
            color: isRegistered ? "red" : "blue", // 🔵 default, 🔴 when registered
            cursor: "pointer",
            fontWeight: "500",
          }}
        >
          {id}. {name}
        </span>
      </div>
    );
  };

  render() {
    return (
      <div className="RosterTuesday1">
        <h3>Thai-Japan Youth Center Participants Day 2</h3>
        <br />
        <br />

        {this.renderParticipant(1, "นายอดิศักดิ์ เก่งประสมทรัพย์")}
        <br />
        {this.renderParticipant(2, "นางสาวอดิศา เก่งประสมทรัพย์")}
        <br />
        {this.renderParticipant(3, "นายสุธีร์ มหัทธนานุสรณ์")}
        <br />
        {this.renderParticipant(4, "นายธนัทสักก์ เกิดโภคาภัยสีห์")}
        <br />
        {this.renderParticipant(5, "นางสาววันนรัตน์ สมบัติภิญโญ")}
        <br />
        {this.renderParticipant(6, "นายสิรวุฒิ วรประทีป์")}
        <br />
        {this.renderParticipant(7, "นางสาวญาณินท์ พิทยสาธรธรรม์")}
        <br />
        {this.renderParticipant(8, "Mr.Kylen Pawarit Jacob")}
        <br />
        {this.renderParticipant(9, "นายพัฒวุฒิ ช่อผกา")}
        <br />
        {this.renderParticipant(10, "นายวชิรวิชญ์ ปัญญาลักษณ์")}
        <br />
        {this.renderParticipant(11, "Mr.Panomkorn Hongprayoon")}
        <br />
        {this.renderParticipant(12, "นางสาวนพเก้า ชุมศรี")}
        <br />
        {this.renderParticipant(13, "Mr.Sarawut Nikom")}
        <br />

        <div>ASEAN AIKIDO FELLOWSHIP SEMINAR 2025 REGISTRATION SYSTEM...</div>
        <br />
        <br />
        <div>Powered by</div>
        <img className="logo2" src={logo2} alt="logo" />
        <div>New Wave Consulting Group</div>
      </div>
    );
  }
}

export default SeminarDindang2;
